export interface ItemAction {
  type: string;
  icon: string;
  info: string;
  features: string[];
}
